var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"row h-100 justify-content-center align-items-center"},[_c('div',{staticClass:"player-wrapper"},[_c('lottie',{attrs:{"options":_vm.lottieOptions}})],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }